
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Travelsagentinpuneforminibushire() {



    const cardData =
    {
        keyword: 'Travel Agents in Pune for Mini Bus Hire',
        heading: 'Samarth Travels: Travel Agents in Pune for Mini Bus Hire',
        headingDescription: 'Samarth Travels offers mini bus hire services in Pune, ideal for family outings, corporate events, school trips, and outstation tours. Our fleet of well-maintained mini buses, including 13, 17, and 20-seater options, comes equipped with air-conditioning, push-back seats, and spacious interiors to ensure a comfortable and enjoyable journey. With experienced drivers, flexible rental packages, and transparent pricing, Samarth Travels provides safe, reliable, and cost-effective mini bus rental solutions across Pune.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

     "services": [
    {
      "name": "Tour Agencies in Pune",
      "description": "Looking for reliable tour agencies in Pune? We provide expert tour services, including customized travel packages for family, corporate outings, and group tours. Our experienced agents ensure a smooth travel experience across Pune and beyond."
    },
    {
      "name": "Bus Hire Agency in Pune",
      "description": "Our bus hire agency in Pune offers a wide range of vehicles for all types of events, corporate outings, and family trips. Whether it's a 14-seater or a 45-seater, our fleet of well-maintained buses ensures comfort and safety for your journey."
    },
    {
      "name": "Tourist Agency in Pune",
      "description": "Our tourist agency in Pune specializes in providing exclusive tour packages to various destinations in Maharashtra and beyond. Whether you want a guided city tour or a nature retreat, our team ensures a memorable travel experience."
    },
    {
      "name": "Travel Agents in Pune",
      "description": "Find the best travel agents in Pune for all your travel needs. From leisure trips to corporate travel solutions, our professional agents offer expert guidance and services to plan your perfect trip."
    },
    {
      "name": "Pune Tours and Travels Agents",
      "description": "Our Pune-based tours and travel agents specialize in organizing customized trips and guided tours. Whether it’s a pilgrimage, a honeymoon, or a corporate outing, we offer tailored travel experiences for all."
    },
    {
      "name": "Bus Hire Agents in Pune",
      "description": "We connect you with the best bus hire agents in Pune. Whether you're planning a wedding, corporate event, or school trip, our agents help you choose the right vehicle for your journey, with options for both AC and non-AC buses."
    },
    {
      "name": "Best Traveller Bus on Rent in Pune",
      "description": "Looking for a comfortable and spacious traveller bus for your group trip in Pune? We provide the best traveller buses on rent, ensuring a smooth and comfortable journey for corporate events, picnics, and family outings."
    },
    {
      "name": "Urbania Bus on Rent in Pune for Corporate Outing",
      "description": "Hire a luxury Urbania bus for your next corporate outing in Pune. Our Urbania buses offer the perfect combination of comfort, style, and space for team outings, corporate meetings, and employee transport."
    },
    {
      "name": "Travel Agents in Pimpri Chinchwad",
      "description": "For all your travel needs in Pimpri Chinchwad, our expert travel agents are here to assist. From booking flights and hotels to planning tours, we provide complete travel solutions at competitive prices."
    },
    {
      "name": "Pune Travel Agency Contact Number",
      "description": "Get in touch with our Pune travel agency today for expert guidance and travel services. Whether you need a bus for a wedding, a tour package, or travel arrangements, our team is ready to assist you."
    },
    {
      "name": "Bus Hire for Events Agency",
      "description": "Looking for buses for your next event? Our event bus hire agency in Pune offers comfortable buses for weddings, corporate events, school picnics, and more. We ensure reliable and timely services for all your transport needs."
    },
    {
      "name": "Bus Hire for Corporate Events & Tours",
      "description": "Our bus hire services for corporate events and tours in Pune cater to all sizes of groups. Whether it's an offsite, team-building exercise, or a conference, we offer a wide range of buses and travel solutions."
    },
    {
      "name": "Bus Booking for Corporate Events",
      "description": "Book a bus for your next corporate event with our Pune-based service. We offer a range of buses from mini buses to large coaches for events like conferences, team building, and business outings."
    },
    {
      "name": "Bus on Hire for Pune to Mahabaleshwar Package Tour",
      "description": "Planning a trip from Pune to Mahabaleshwar? Hire a bus with us for your group tour. We offer a range of buses suitable for large and small groups, ensuring a comfortable and enjoyable journey."
    },
    {
      "name": "Tour Operators in Pune",
      "description": "Our tour operators in Pune provide customized packages for individuals and groups. From scenic tours in Maharashtra to outstation travel, our operators ensure every detail of your trip is taken care of."
    },
    {
      "name": "Best Tours and Travel Company in PCMC",
      "description": "For the best travel and tour services in Pimpri Chinchwad, choose our expert travel company. We offer a variety of travel packages, vehicle rentals, and tour planning services for all types of travelers."
    },
    {
      "name": "Best Tours and Travel Company in Pune",
      "description": "We are one of the best tours and travel companies in Pune, offering a range of travel services including package tours, bus hire, flight bookings, and more. Our team ensures a hassle-free travel experience for you."
    },
    {
      "name": "Travel Agents Pune",
      "description": "Find trusted travel agents in Pune who can assist with flight bookings, holiday packages, and transportation services. Our agents offer personalized travel experiences to suit your needs."
    },
    {
      "name": "Best Tour and Travel Agency in Pune",
      "description": "Looking for the best tour and travel agency in Pune? We specialize in providing exceptional travel services, including customized tours, transport arrangements, and vacation planning."
    },
    {
      "name": "Local Travel Agency Near Me in Pune",
      "description": "Looking for a local travel agency near you in Pune? Our agency offers tailored travel services including bus hire, tour packages, and transport booking for both local and outstation trips."
    }
  ],
  "tableData": [
    ["Tour Agencies in Pune", "Bus Hire Agency in Pune"],
    ["Tourist Agency in Pune", "Travel Agents in Pune"],
    ["Pune Tours and Travels Agents", "Bus Hire Agents in Pune"],
    ["Best Traveller Bus on Rent in Pune", "Urbania Bus on Rent in Pune for Corporate Outing"],
    ["Travel Agents in Pimpri Chinchwad", "Pune Travel Agency Contact Number"],
    ["Bus Hire for Events Agency", "Bus Hire for Corporate Events & Tours"],
    ["Bus Booking for Corporate Events", "Bus on Hire for Pune to Mahabaleshwar Package Tour"],
    ["Tour Operators in Pune", "Best Tours and Travel Company in PCMC"],
    ["Best Tours and Travel Company in Pune", "Travel Agents Pune"],
    ["Best Tour and Travel Agency in Pune", "Local Travel Agency Near Me in Pune"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Travel Agents for Mini Bus Hire in Pune",
        "WhyChoosedescription": "Our travel agency specializes in providing mini bus hire services in Pune, offering dependable and hassle-free travel experiences. Whether it's a corporate event, family trip, or school outing, we help you find the best mini bus for your needs with top-notch service."
    },
    {
        "WhyChooseheading": "Wide Range of Mini Buses for Every Group Size",
        "WhyChoosedescription": "We offer a variety of mini buses, including 14-seater, 17-seater, and 20-seater options, perfect for small to medium-sized groups. Our buses are equipped with modern amenities like air-conditioning, comfortable seating, and plenty of space for luggage."
    },
    {
        "WhyChooseheading": "Experienced Travel Agents for Seamless Service",
        "WhyChoosedescription": "Our experienced travel agents will guide you through the mini bus hire process, ensuring a smooth booking experience and helping you select the right bus based on your travel needs, preferences, and budget."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide mini bus rental services at competitive rates with no hidden costs. Whether you need a bus for a few hours or a full day, our transparent pricing ensures that you know exactly what to expect."
    },
    {
        "WhyChooseheading": "Personalized Travel Plans for Every Occasion",
        "WhyChoosedescription": "From corporate team-building trips to family gatherings and school outings, our travel agents offer personalized solutions to match your specific event and itinerary. We can help arrange all the logistics to ensure a smooth and enjoyable experience."
    },
    {
        "WhyChooseheading": "Punctual and Professional Drivers",
        "WhyChoosedescription": "We provide professional, experienced, and courteous drivers who are familiar with Pune's roads and travel routes. Our drivers ensure timely departures and safe, smooth travel throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
        "WhyChoosedescription": "Our travel agents and mini bus hire services are available 24/7, accommodating any time of day or night, so you can schedule your trip according to your convenience without any delays."
    },
    {
        "WhyChooseheading": "Easy Booking Process with Real-Time Updates",
        "WhyChoosedescription": "Booking a mini bus with our travel agency is simple and quick. After confirming your booking, you will receive real-time updates, including driver details, bus tracking, and live journey notifications."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Mini Buses",
        "WhyChoosedescription": "All our mini buses are thoroughly cleaned and sanitized before every journey to ensure the safety and comfort of our passengers. Regular maintenance checks keep our buses in excellent condition."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Transactions",
        "WhyChoosedescription": "Our travel agency provides various payment methods including UPI, credit/debit cards, digital wallets, and cash, making the booking process fast, easy, and secure."
    }
]



























    }

const faqData = [
    {
        id: 1,
        question: 'How do I hire a mini bus in Pune with Samarth Travels?',
        answer: 'Hiring a mini bus with Samarth Travels is easy. Simply contact us through our website or phone, provide your trip details (pickup location, destination, date, and number of passengers), and we will help you choose the right mini bus for your journey.',
    },
    {
        id: 2,
        question: 'What types of mini buses are available for hire in Pune?',
        answer: 'Samarth Travels offers various mini buses in different seating configurations, such as 14-seater, 17-seater, and 20-seater mini buses. Whether for corporate trips, family outings, or school excursions, we provide both AC and non-AC options.',
    },
    {
        id: 3,
        question: 'Are the mini buses suitable for long-distance travel?',
        answer: 'Yes, our mini buses are ideal for both local and long-distance travel. They are equipped with comfortable seating, air conditioning (AC), and ample space for luggage. Whether you’re traveling within Pune or going outstation, our mini buses offer a comfortable ride.',
    },
    {
        id: 4,
        question: 'What are the rental charges for mini buses in Pune?',
        answer: 'Rental charges for mini buses in Pune typically start at ₹32/km for non-AC and ₹35/km for AC buses. We also offer flexible hourly packages, such as 4 hours/35 km and 8 hours/80 km, and custom pricing for outstation trips. Contact us for a quote based on your specific needs.',
    },
    {
        id: 5,
        question: 'Does the rental include a driver and fuel?',
        answer: 'Yes, all mini bus rentals include a professional driver and fuel costs. Additional charges such as tolls, parking fees, and permits will be communicated upfront to avoid any surprises.',
    },
    {
        id: 6,
        question: 'Can I customize the pickup and drop-off points for mini bus hire?',
        answer: 'Absolutely! You can customize your pickup and drop-off locations based on your convenience. Whether you need to be picked up from your office, hotel, or home, we will ensure your mini bus is ready on time.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for mini bus rentals?',
        answer: 'Yes, Samarth Travels offers 24/7 customer support for mini bus rentals. If you need assistance with booking, have special requests, or need any help during your trip, our team is available to assist you at any time.',
    },
];

const testimonials = [
    {
        name: 'Mr. Shankar Rathi',
        role: 'Corporate Manager',
        text: 'We hired a 17-seater mini bus for our corporate outing to Lonavala. The bus was spacious, comfortable, and the driver was very professional. The whole booking process was hassle-free. Highly recommend Samarth Travels!',
        image: '/img/testimonial/testi_minibus_shankar.jpg',
    },
    {
        name: 'Mrs. Neha Agarwal',
        role: 'Event Planner',
        text: 'I rented a 14-seater mini bus for a family trip to Khandala. The mini bus was clean, well-maintained, and the air-conditioning worked perfectly. Our family had a wonderful time. Thank you, Samarth Travels, for making our trip so smooth!',
        image: '/img/testimonial/testi_minibus_neha.jpg',
    },
    {
        name: 'Mr. Rahul Kumar',
        role: 'School Coordinator',
        text: 'We used a 20-seater mini bus for a school excursion to Pune city. The bus was spacious and comfortable for the kids, and the driver was punctual and friendly. Samarth Travels made the booking process very easy.',
        image: '/img/testimonial/testi_minibus_rahul.jpg',
    },
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Travel Agents in Pune for Mini Bus Hire",
  "image": "https://samarthtravels.com/assets/images/travel-agents-mini-bus-hire-pune.jpg", // Replace with the correct image URL
  "description": "Looking for travel agents in Pune for mini bus hire? Samarth Travels offers expert bus booking services for corporate events, group tours, Mahabaleshwar packages, and more. Available across Pune and Pimpri Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5612"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6300",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/travel-agents-in-pune-mini-bus-hire" // Replace with the actual page URL
  }
};



    return (
        <div>



<Helmet>
  <title>Travel Agents in Pune for Mini Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Hire mini buses in Pune through trusted travel agents. Samarth Travels offers rental services for corporate trips, weddings, events, and outstation tours. Contact the best tour and travel agency in Pune & Pimpri Chinchwad." 
  />
  <meta 
    name="keywords" 
    content="Tour Agencies In Pune, Bus Hire Agency in Pune, Tourist agency in pune, Travel agents in pune, Pune tours and travels agents, bus hire agents in pune, best traveller bus on rent in pune, urbania bus on rent in pune for corporate outing, Travel Agents In Pimpri Chinchwad, pune travel agency contact Number, Bus Hire for Events Agency, Bus Hire For Corporate Events & Tours, Bus Booking for Corporate Events, Bus on Hire on Pune to Mahabaleshwar Package Tour, tour operators in pune, best tours and travel company in pcmc, Best tours and travel company in Pune, Travel Agents Pune, Best Tour and Travel Agency in Pune, Local travel agency near me in pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Travelsagentinpuneforminibushire;